import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage, WEB_SERVICE_MIMS, protocols, applications } from "../../../../config/constants";
// Components
import { MainContainer, BackLink, ArrowImg, LinkText, PreviousAndNextDiv, NavigationButton, SeparatorDiv } from "./styles";
import Axios from "../../../../config/axios";
// Assets
import ArrowBackImg from "../../../../assets/ico_arrow_back.svg";
import ArrowLeftImg from "../../../../assets/ico_arrow_left_bold.svg";
import ArrowRightImg from "../../../../assets/ico_arrow_right_bold.svg";

const ProtocolNavigation = () => {
  const { patientId, protocolId, software } = useParams();
  const [currentProtocols, setCurrentProtocols] = useState([]);
  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const hospitalId = useSelector(({ clinician }) => clinician.data.HOSPITAL_ID);
  const [t] = useTranslation("global");

  useEffect(() => {
    const handleAddProtocol = (protocolsArray, activeProtocols, hospitalProtocols) => {
      protocolsArray.forEach((protocol) => {
        if (hospitalProtocols.includes(protocol.id) && protocol.isActive) {
          activeProtocols.push(protocol.id);
        }
      });
    };

    const handleSetCurrentProtocols = (softwareId, protocolsBySoftwareParams) => {
      Axios("get", `${WEB_SERVICE_MIMS}/hospitals/protocols/${softwareId}/${hospitalId}`)
        .then(({ data }) => {
          const hospitalProtocols = [];
          data.forEach((protocol) => {
            hospitalProtocols.push(protocol.PROTOCOL_ID);
          });
          const protocolsBySoftware = Object.values(protocolsBySoftwareParams);
          const activeProtocols = [];
          handleAddProtocol(protocolsBySoftware, activeProtocols, hospitalProtocols);
          setCurrentProtocols(activeProtocols);
        })
        .catch((error) => {
          console.log("endpoint to get hospital protocols: ", error);
        });
    };

    switch (software) {
      case "clinic":
        handleSetCurrentProtocols(applications.clinicId, protocols.clinicAndHome);
        break;
      case "home":
        handleSetCurrentProtocols(applications.homeId, protocols.clinicAndHome);
        break;
      default:
        break;
    }
  }, [hospitalId, software]);

  const newUrlToReports = (protocolId) => {
    window.location.href = `${pathHomePage}/reports/${clinicianToken}/${software}/${patientId}/${protocolId}`;
  };

  const handleRedirectPreviousProtocol = () => {
    const previousProtocolIdIndex = currentProtocols.indexOf(Number(protocolId)) - 1;
    const previousProtocolId = currentProtocols.at(previousProtocolIdIndex);
    newUrlToReports(previousProtocolId);
  };

  const handleRedirectNextProtocol = () => {
    const nextProtocolIdIndex = currentProtocols.indexOf(Number(protocolId)) + 1;
    let nextProtocolId;
    if (nextProtocolIdIndex === currentProtocols.length) {
      nextProtocolId = currentProtocols.shift();
    } else {
      nextProtocolId = currentProtocols.at(nextProtocolIdIndex);
    }
    newUrlToReports(nextProtocolId);
  };

  return (
    <MainContainer>
      <BackLink to={`${pathHomePage}/prescriptions/${software}/${clinicianToken}/${patientId}`}>
        <ArrowImg src={ArrowBackImg} alt="ico-arrow-back" margin="0 10px 0 0" margin960="0 5px 0 0" />
        <LinkText>{t("reports.protocolNavigation.activities")}</LinkText>
      </BackLink>
      <PreviousAndNextDiv>
        <NavigationButton onClick={handleRedirectPreviousProtocol}>
          <ArrowImg src={ArrowLeftImg} alt="ico-arrow-left" margin="0 10px 0 0" margin960="0 5px 0 0" />
          <LinkText>{t("reports.protocolNavigation.previous")}</LinkText>
        </NavigationButton>
        <SeparatorDiv />
        <NavigationButton onClick={handleRedirectNextProtocol}>
          <LinkText>{t("reports.protocolNavigation.next")}</LinkText>
          <ArrowImg src={ArrowRightImg} alt="ico-arrow-right" margin="0 0 0 10px" margin960="0 0 0 5px" />
        </NavigationButton>
      </PreviousAndNextDiv>
    </MainContainer>
  );
};

export default ProtocolNavigation;
